






(function () {
  if (window.faqSplitLoaded) return;
  window.faqSplitLoaded = true;
  var DURATION = 300;

  function collapse(item) {
    var answer = item.querySelector('.faq-answer');
    var icon = item.querySelector('.icon');
    var trigger = item.querySelector('.faq-question');
    if (!answer) return;

    answer.style.height = answer.scrollHeight + 'px';
    void answer.offsetHeight;
    item.classList.remove('active');
    answer.style.height = '0px';
    if (icon) icon.textContent = '+';
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function expand(item) {
    var answer = item.querySelector('.faq-answer');
    var icon = item.querySelector('.icon');
    var trigger = item.querySelector('.faq-question');
    if (!answer) return;

    item.classList.add('active');
    answer.style.height = answer.scrollHeight + 'px';
    if (icon) icon.textContent = '−';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    clearTimeout(answer._settleTimer);
    answer._settleTimer = setTimeout(function () {
      if (item.classList.contains('active')) answer.style.height = 'auto';
    }, DURATION);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.faq-question');
    if (!trigger) return;

    var item = trigger.closest('.faq-item');
    var section = trigger.closest('.faq-split-section');
    if (!item || !section) return;

    var wasOpen = item.classList.contains('active');
    section.querySelectorAll('.faq-item.active').forEach(collapse);
    if (!wasOpen) expand(item);
  });
})();
